module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/004-oman-f4c54bc3506bbe14f95c5af595849e2f.svg";